<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="toTop"></div>
    <div class="all-header">
      <div class="final-nav">
        <!-- Logo图片居左 -->
        <div class="nav-logo">
          <img
            src="@/components/img/logoEN.png"
            alt="华胤Logo"
            class="logo-img"
            @click="tohomeen"
          />
        </div>

        <!-- 桌面导航居右 -->
        <el-menu
          v-if="!isMobile"
          key="desktop"
          class="desktop-nav"
          mode="horizontal"
          @select="handleSelect"
          text-color="#000000"
          active-text-color="#000000"
        >
          <el-menu-item index="home" @click="tohomeen" class="nav-item">
            <span class="oneItem">Home</span>
          </el-menu-item>

          <el-submenu index="about" class="nav-item">
            <template slot="title"><span class="oneItem">About</span></template>
            <el-menu-item index="gyhy1" @click="togyhyen1">
              <span class="twoItem">Milestone</span></el-menu-item
            >
            <el-menu-item index="gyhy2" @click="togyhyen2"
              ><span class="twoItem">Mission</span></el-menu-item
            >
            <el-menu-item index="gyhy3" @click="togyhyen3"
              ><span class="twoItem">Vision</span></el-menu-item
            >
            <el-menu-item index="gyhy4" @click="togyhyen4"
              ><span class="twoItem">ESG</span></el-menu-item
            >
            <el-menu-item index="gyhy5" @click="togyhyen5"
              ><span class="twoItem">Factory Introduction</span></el-menu-item
            >
            <el-menu-item index="gyhy6" @click="togyhyen6"
              ><span class="twoItem"
                >Certifications & Awards</span
              ></el-menu-item
            >
          </el-submenu>

          <el-submenu index="product" class="nav-item">
            <template slot="title"
              ><span class="oneItem">Technology & Products</span></template
            >
            <el-menu-item index="cpyfw1" @click="tocpyfwen1"
              ><span class="twoItem">Engineering & Design</span></el-menu-item
            >
            <el-menu-item index="cpyfw2" @click="tocpyfwen2"
              ><span class="twoItem">System Products</span></el-menu-item
            >
            <el-menu-item index="cpyfw3" @click="tocpyfwen3"
              ><span class="twoItem">Far East Patents</span></el-menu-item
            >
            <el-menu-item index="cpyfw4" @click="tocpyfwen4"
              ><span class="twoItem">Erection</span></el-menu-item
            >
            <el-menu-item index="cpyfw5" @click="tocpyfwen5"
              ><span class="twoItem">GS Solar Power</span></el-menu-item
            >
          </el-submenu>

          <el-submenu index="quality" class="nav-item">
            <template slot="title"
              ><span class="oneItem">Quality & Safety</span></template
            >
            <el-menu-item index="pzyaq1" @click="topzyaqen1"
              ><span class="twoItem">Quality Management</span></el-menu-item
            >
            <el-menu-item index="pzyaq2" @click="topzyaqen2"
              ><span class="twoItem">Product Quality</span></el-menu-item
            >
            <el-menu-item index="pzyaq3" @click="topzyaqen3"
              ><span class="twoItem">Product Packaging</span></el-menu-item
            >
            <el-menu-item index="pzyaq4" @click="topzyaqen4"
              ><span class="twoItem"
                >Occupational Safety Policy</span
              ></el-menu-item
            >
          </el-submenu>
          <el-menu-item index="gcjs" @click="togcyjen" class="nav-item"
            ><span class="oneItem">Projects</span></el-menu-item
          >
          <el-menu-item index="news" @click="tozxxxen" class="nav-item"
            ><span class="oneItem">News</span></el-menu-item
          >
          <!-- <el-menu-item index="language" @click="changeLan" class="language-item">
          <i class="glyphicon glyphicon-globe"></i>
          <span class="oneItem" @click="changeLan()">CN</span>
        </el-menu-item> -->
          <el-submenu index="language" class="nav-item">
            <template slot="title"
              ><span class="oneItem">Language</span></template
            >
            <el-menu-item index="english" @click="toZh"
              ><span class="twoItem">Mandarin</span></el-menu-item
            >
            <el-menu-item index="japan" @click="toJp"
              ><span class="twoItem">Japanese</span></el-menu-item
            >
          </el-submenu>
        </el-menu>

        <!-- 移动端菜单按钮 -->
        <div class="mobile-nav" v-if="isMobile">
          <div class="hamburger-btn" @click="openMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <el-drawer
            :visible.sync="drawerVisible"
            direction="ltr"
            size="75%"
            :modal="true"
            :modal-append-to-body="false"
            custom-class="optimized-drawer"
            @open="lockBodyScroll"
            @close="unlockBodyScroll"
            :with-header="false"
          >
            <el-menu
              class="mobile-menu"
              :default-active="activeIndex"
              @select="handleSelect"
            >
              <el-menu-item index="home" @click="tohomeen" class="mobile-item">
                <i class="el-icon-house"></i>
                <span class="oneItem">Home</span>
              </el-menu-item>

              <el-submenu index="about" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem">About</span>
                </template>
                <el-menu-item index="gyhy1" @click="togyhyen1"
                  ><span class="twoItem">Milestone</span></el-menu-item
                >
                <el-menu-item index="gyhy2" @click="togyhyen2"
                  ><span class="twoItem">Mission</span></el-menu-item
                >
                <el-menu-item index="gyhy3" @click="togyhyen3"
                  ><span class="twoItem">Vision</span></el-menu-item
                >
                <el-menu-item index="gyhy4" @click="togyhyen4"
                  ><span class="twoItem">ESG</span></el-menu-item
                >
                <el-menu-item index="gyhy5" @click="togyhyen5"
                  ><span class="twoItem"
                    >Factory Introduction</span
                  ></el-menu-item
                >
                <el-menu-item index="gyhy6" @click="togyhyen6"
                  ><span class="twoItem"
                    >Certifications & Awards</span
                  ></el-menu-item
                >
              </el-submenu>

              <el-submenu index="product" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem">Technology & Products</span>
                </template>
                <el-menu-item index="cpyfw1" @click="tocpyfwen1"
                  ><span class="twoItem"
                    >Engineering & Design</span
                  ></el-menu-item
                >
                <el-menu-item index="cpyfw2" @click="tocpyfwen2"
                  ><span class="twoItem">System Products</span></el-menu-item
                >
                <el-menu-item index="cpyfw3" @click="tocpyfwen3"
                  ><span class="twoItem">Far East Patents</span></el-menu-item
                >
                <el-menu-item index="cpyfw4" @click="tocpyfwen4"
                  ><span class="twoItem">Erection</span></el-menu-item
                >
                <el-menu-item index="cpyfw5" @click="tocpyfwen5"
                  ><span class="twoItem">GS Solar Power</span></el-menu-item
                >
              </el-submenu>

              <el-submenu index="quality" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem">Quality & Safety</span>
                </template>
                <el-menu-item index="pzyaq1" @click="topzyaqen1"
                  ><span class="twoItem">Quality Management</span></el-menu-item
                >
                <el-menu-item index="pzyaq2" @click="topzyaqen2"
                  ><span class="twoItem">Product Quality</span></el-menu-item
                >
                <el-menu-item index="pzyaq3" @click="topzyaqen3"
                  ><span class="twoItem">Product Packaging</span></el-menu-item
                >
                <el-menu-item index="pzyaq4" @click="topzyaqen4"
                  ><span class="twoItem"
                    >Occupational Safety Policy</span
                  ></el-menu-item
                >
              </el-submenu>

              <el-menu-item index="gcjs" @click="togcyjen" class="mobile-item">
                <i class="el-icon-notebook-2"></i>
                <span class="oneItem">Projects</span>
              </el-menu-item>

              <el-menu-item index="news" @click="tozxxxen" class="mobile-item">
                <i class="el-icon-news"></i>
                <span class="oneItem">News</span>
              </el-menu-item>

              <el-submenu index="language" class="mobile-item">
                <template slot="title">
                  <img
                    src="@/components/img/diqiu.png"
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="oneItem" index="/language">Language</span>
                </template>
                <el-menu-item index="language1" @click="toZh"
                  ><span class="twoItem">繁体中文</span></el-menu-item
                >
                <el-menu-item index="language2" @click="toJp"
                  ><span class="twoItem">日本語</span></el-menu-item
                >
              </el-submenu>

              <!-- <el-menu-item index="language" @click="changeLan" class="mobile-item">
              <i class="el-icon-sort"></i>
              <span class="oneItem">CN</span>
            </el-menu-item> -->

              <el-menu-item
                index="close"
                @click="drawerVisible = false"
                class="close-item"
              >
                <i class="el-icon-close"></i>
                <span class="oneItem">Close</span>
              </el-menu-item>
            </el-menu>
          </el-drawer>
        </div>
      </div>
    </div>
    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import Loader from '../skip/Loader.vue'
export default {
  props: {
    Language: String,
  },
  data() {
    return {
      isLoading: false,
      activeIndex: 'home',
      isMobile: false,
      drawerVisible: false,
      resizeTimer: null,
    }
  },
  methods: {
    // changeLan() {
    //   this.$emit('ZLchange')
    // },
    // toEng(){
    //   this.$emit('ELchange')
    // },
    toZh() {
      this.$emit('ZLchange')
    },
    toJp() {
      this.$emit('JLchange')
    },

    handleSelect(index) {
      if (index === 'close') return
      this.activeIndex = index
      if (this.isMobile) {
        this.drawerVisible = false
      }
    },
    checkMobile() {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        const wasMobile = this.isMobile
        this.isMobile = window.innerWidth < 1400

        if (wasMobile && !this.isMobile) {
          this.drawerVisible = false
        }
      }, 200)
    },
    // 首頁
    tohomeen() {
      if (this.$route.fullPath != '/homeen') {
        this.isLoading = true
        this.$router
          .push('/homeen')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 關於華胤
    togyhyen1() {
      if (this.$route.fullPath != '/gyhyen') {
        this.isLoading = true
        this.$router
          .push('/gyhyen')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyen2() {
      if (this.$route.fullPath != '/gyhyen#hymb') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyen',
            hash: '#hymb',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyen3() {
      if (this.$route.fullPath != '/gyhyen#hyyj') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyen',
            hash: '#hyyj',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyen4() {
      if (this.$route.fullPath != '/gyhyen#esg') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyen',
            hash: '#esg',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyen5() {
      if (this.$route.fullPath != '/gyhyen#gcjs') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyen',
            hash: '#gcjs',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyen6() {
      if (this.$route.fullPath != '/gyhyen#rzjx') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyen',
            hash: '#rzjx',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 产品与服务
    tocpyfwen1() {
      if (this.$route.fullPath != '/cpyfwen') {
        this.isLoading = true
        this.$router
          .push('/cpyfwen')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwen2() {
      if (this.$route.fullPath != '/cpyfwen#xtcp') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwen',
            hash: '#xtcp',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwen3() {
      if (this.$route.fullPath != '/cpyfwen#hyzl') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwen',
            hash: '#hyzl',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwen4() {
      if (this.$route.fullPath != '/cpyfwen#azfw') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwen',
            hash: '#azfw',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwen5() {
      if (this.$route.fullPath != '/cpyfwen#gsxny') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwen',
            hash: '#gsxny',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 品质与安全
    topzyaqen1() {
      if (this.$route.fullPath != '/pzyaqen') {
        this.isLoading = true
        this.$router
          .push('/pzyaqen')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaqen2() {
      if (this.$route.fullPath != '/pzyaqen#cpzl') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaqen',
            hash: '#cpzl',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaqen3() {
      if (this.$route.fullPath != '/pzyaqen#cpbz') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaqen',
            hash: '#cpbz',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaqen4() {
      if (this.$route.fullPath != '/pzyaqen#aqzc') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaqen',
            hash: '#aqzc',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 工程业绩
    togcyjen() {
      if (this.$route.fullPath != '/gcyjen') {
        this.isLoading = true
        this.$router
          .push('/gcyjen')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 最新消息
    tozxxxen() {
      if (this.$route.fullPath != '/zxxxen') {
        this.isLoading = true
        this.$router
          .push('/zxxxen')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },

    openMobileMenu() {
      this.drawerVisible = true
    },
    lockBodyScroll() {
      document.body.classList.add('mobile-nav-open')
      document.addEventListener('wheel', this.preventScroll, { passive: false })
    },
    unlockBodyScroll() {
      document.body.classList.remove('mobile-nav-open')
      document.removeEventListener('wheel', this.preventScroll)
    },
    preventScroll(e) {
      if (this.drawerVisible) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    clearTimeout(this.resizeTimer)
  },
  components: {
    Loader,
  },
}
</script>

<style scoped>
.toTop {
  width: 100%;
  height: 80px;
}
.all-header {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100vw;
  max-width: 100vw;
  background-color: #fff;
}
.final-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 84px;
  position: relative;
  z-index: 1000;
  width: 95vw;
  margin: 0 auto;
}

.nav-logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 75px;
  width: auto;
}

.desktop-nav {
  border-bottom: none;
  display: flex;
  align-items: center;
  height: 80px;
}

/* 桌面版菜单项与分割线 */
.nav-item {
  position: relative;
  padding: 0 20px;
}
.nav-item:not(:last-child):after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 16px;
  width: 1px;
  background-color: #e6e6e6;
}

.language-item i {
  margin-right: 5px;
}

/* 移动端三横线按钮 */
.hamburger-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 20px;
  height: 14px;
  cursor: pointer;
}
.hamburger-btn span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #333;
  transition: all 0.3s;
}

/* 移动端菜单样式 */
.optimized-drawer {
  pointer-events: none;
}

.optimized-drawer .el-drawer__container {
  pointer-events: auto;
}

.optimized-drawer .el-drawer__mask {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.3);
}
.mobile-menu {
  border-right: none;
  padding-top: 10px;
}

/* 移动端菜单项与分割线 */
.mobile-item {
  border-bottom: 1px solid #f5f5f5;
}
.mobile-item:last-child {
  border-bottom: none;
}

.close-item {
  margin-top: 10px;
  border-top: 1px solid #e6e6e6;
}

.oneItem {
  font-size: 18px;
  font-weight: bolder;
}
.twoItem {
  font-size: 16px;
  font-weight: 400;
  margin: 10px 0;
}
div /deep/ .el-submenu__title {
  padding: 0;
}

.el-menu--horizontal .el-menu--popup {
  padding: 5px 0;
}
.el-menu--horizontal .el-menu--popup .el-menu-item {
  height: 40px;
  line-height: 40px;
  transition: all 0.2s;
  border-top: 1px solid #f5f5f5;
}
.el-menu--horizontal .el-menu--popup .el-menu-item:first-child {
  border-top: 6px solid #5e5e5e;
}

.el-menu--horizontal .el-menu--popup .el-menu-item:hover {
  background: rgb(96, 96, 96);
}
.el-menu--horizontal .el-menu--popup .el-menu-item:hover .twoItem {
  color: #fff;
  transform: translateX(3px);
}

/* 移动版 */
.mobile-menu .el-menu-item {
  transition: all 0.3s;
}
.mobile-menu .el-menu-item:hover {
  background: var(--hover-bg-color);
}
.mobile-menu .el-menu-item:hover .twoItem {
  color: green;
}

/* 响应式断点 */
/* 响应式断点 */
@media (max-width: 1400px) {
  .toTop {
    width: 100%;
    height: 80px;
  }
  .desktop-nav {
    display: none;
  }
  .mobile-nav {
    display: block;
  }
  .final-nav {
    height: 80px;
    width: 98vw;
    padding: 0 15px 0 5px;
  }
  .logo-img {
    height: 60px;
  }
  .oneItem {
    font-size: 17px;
    font-weight: normal;
  }
  .twoItem {
    font-size: 16px;
    font-weight: normal;
  }
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 19px;
    cursor: pointer;
  }
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .el-menu-item:hover {
    background: var(--hover-bg-color) !important;
  }
}

/* 响应式断点 */
@media (max-width: 767px) {
  .toTop {
    width: 100%;
    height: 56px;
  }
  .desktop-nav {
    display: none;
  }
  .mobile-nav {
    display: block;
  }
  .final-nav {
    height: 56px;
    width: 100vw;
    padding: 0 15px 0 5px;
  }
  .logo-img {
    height: 42px;
  }
  .oneItem {
    font-size: 14px;
    font-weight: normal;
  }
  .twoItem {
    font-size: 13px;
    font-weight: normal;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .el-menu-item:hover {
    background: var(--hover-bg-color) !important;
  }
}

@media (min-width: 1400px) {
  .mobile-nav {
    display: none;
  }
}
@media (min-width: 2000px) {
  .oneItem {
    font-size: 25px;
  }
  .twoItem {
    font-size: 19px;
  }
  .logo-img {
    height: 80px;
  }
  .el-menu--horizontal .el-menu--popup .el-menu-item {
    height: 50px;
    line-height: 50px;
  }
}
</style>
